import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL, SITE_URL } from "@/mocks/site";

export default function SiteFooter({ lang }: { lang: string }) {
  const { t } = useTranslation();

  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-grid-line text-lg" />
              </span>
              <span className="font-heading text-base font-bold text-foreground-900">usfanslink.lol</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">{t("footer.about")}</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900">
              <a href={`${SITE_URL}/${lang}`} className="transition-colors hover:text-primary-700">
                {t("footer.quickLinks")}
              </a>
            </h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to={`/${lang}`} className="text-foreground-600 transition-colors hover:text-primary-700">
                  {t("nav.home")}
                </Link>
              </li>
              <li>
                <Link
                  to={`/${lang}/article/usfans-spreadsheet-guide`}
                  className="text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t("nav.guide")}
                </Link>
              </li>
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t("cta.spreadsheet")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900">{t("footer.disclaimer")}</h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">{t("footer.disclaimerText")}</p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-background-200 pt-6 text-sm text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} usfanslink.lol. {t("footer.rights")}</span>
          <span className="text-foreground-400">{t("brand.subtag")}</span>
        </div>
      </div>
    </footer>
  );
}